<template>
    <header class="header">
        <div class="container">
            <a class="col-4 col-md-2" href="https://www.tecnotion.com/">
                <img src="@/assets/images/Tecnotion_logo_2021_White.png" />
            </a>

            <div class="col-6 col-md-8 header__title">
                <h1>{{ $t('common.simulationTool') }}</h1>
            </div>

            <div class="col-2">
                <language-switcher />
            </div>
        </div>
    </header>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import LanguageSwitcher from './LanguageSwitcher';

@Component({
    components: { LanguageSwitcher },
})
export default class TheHeader extends Vue {}
</script>
